import { render, staticRenderFns } from "./AffairItemCommentChat.vue?vue&type=template&id=b4eeb24e&scoped=true"
import script from "./AffairItemCommentChat.vue?vue&type=script&lang=js"
export * from "./AffairItemCommentChat.vue?vue&type=script&lang=js"
import style0 from "./AffairItemCommentChat.vue?vue&type=style&index=0&id=b4eeb24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4eeb24e",
  null
  
)

export default component.exports